<template>
    <Modal
        :title="minMD ? $t('modal.dos.good_document') : undefined"
        no-actions
        with-close-action
        should-open-in-bottom-sheet
        @close="close(false)"
    >
        <template #content>
            <div class="w-full mb-5 md:py-4 md:px-6 md:rounded-lg md:bg-green-50 md:border border-green-200">
                <p class="flex items-center font-body-1-medium text-green-500 mb-2">
                    {{ $t('modal.dos.upload.title') }}
                    <i class="icon icon-checkmark-outlined ml-2" />
                </p>
                <ul class="list-disc ml-3 font-caption-regular leading-6 text-green-500">
                    <li>
                        <span class="text-slate-600">{{ $t('modal.dos.upload.info_1') }}</span>
                    </li>
                    <li class="text-green-500">
                        <span class="text-slate-600">{{ $t('modal.dos.upload.info_2') }}</span>
                    </li>
                    <li>
                        <span class="text-slate-600">{{ $t('modal.dos.upload.info_3') }}</span>
                    </li>
                    <li>
                        <span class="text-slate-600">{{ $t('modal.dos.upload.info_4') }}</span>
                    </li>
                    <li>
                        <span class="text-slate-600">{{ $t('modal.dos.upload.info_5') }}</span>
                    </li>
                </ul>
            </div>
            <div class="w-full md:py-4 md:px-6 md:rounded-lg md:bg-red-50 md:border border-red-200">
                <p class="flex items-center font-body-1-medium text-red-400 mb-2">
                    {{ $t('modal.dos.dont_upload.title') }}
                    <i class="icon icon-incorrect ml-2" />
                </p>
                <ul class="list-disc ml-3 font-caption-regular leading-6 text-red-400">
                    <li>
                        <span class="text-slate-600">{{ $t('modal.dos.dont_upload.info_1') }}</span>
                    </li>
                    <li>
                        <span class="text-slate-600">{{ $t('modal.dos.dont_upload.info_2') }}</span>
                    </li>
                    <li>
                        <span class="text-slate-600">{{ $t('modal.dos.dont_upload.info_3') }}</span>
                    </li>
                    <li>
                        <span class="text-slate-600">{{ $t('modal.dos.dont_upload.info_4') }}</span>
                    </li>
                </ul>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ModalMixin from '@/mixins/modalMixin';
import Modal from '@/components/Modal';
import { useScreenSize } from '@/composables/screenSize';

export default defineComponent({
    name: 'ModalDos',
    components: {
        Modal,
    },
    extends: ModalMixin,
    setup() {
        const { minMD } = useScreenSize();
        return {
            minMD,
        };
    },
});
</script>

<style lang="scss" scoped></style>
